import { UsedDiscount } from '@usacsmideo/types';
import * as Sentry from '@sentry/browser';
import { auth } from '../../constants/firebaseModular';

export const markDiscountUsed = async (payload: UsedDiscount) => {
  const { code, discount, domain, product, uid } = payload;
  const url = `${import.meta.env.VITE_CLOUDFUNCTIONS_URI}/commerceApi/discountCodes/use?uid=${uid}&code=${code}&discount=${discount}&domain=${domain}&product=${product}`;
  const token = await auth.currentUser?.getIdToken();
  if (!token) {
    throw new Error('User is not authenticated');
  }

  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const res = await fetch(url, {
    method: 'POST',
    headers: myHeaders,
  });

  const data = await res.json();

  if (res.status !== 200) {
    const errorMessage = data.error || 'Unable to apply discount code. Please try again or contact support.';
    Sentry.captureException(new Error(`markDiscountUsed failed: ${res.status} - ${errorMessage}`));
    throw new Error(errorMessage);
  }

  return data;
};
